import { render, staticRenderFns } from "./DetailedComparisonModal.vue?vue&type=template&id=e863c288&scoped=true&"
import script from "./DetailedComparisonModal.vue?vue&type=script&lang=js&"
export * from "./DetailedComparisonModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailedComparisonModal.vue?vue&type=style&index=0&id=e863c288&prod&scoped=true&lang=css&"
import style1 from "./DetailedComparisonModal.vue?vue&type=style&index=1&id=e863c288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e863c288",
  null
  
)

export default component.exports